import { render } from "./auditForm.vue?vue&type=template&id=7bed996e"
import script from "./auditForm.vue?vue&type=script&lang=js"
export * from "./auditForm.vue?vue&type=script&lang=js"
script.render = render

export default script